import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import ThreeJS from './components/ThreeJS';

function App() {
  return (
    <div>
      <ThreeJS/>
    </div>
  );
}

export default App;
